import { Accordion, AccordionDetails, Button, Spin, Typography } from '@fox/atoms';
import { nanoid } from 'nanoid';
import { MembershipFormFieldTypes } from '../../membership-form-template/contracts';
import { MembershipAddressesField } from '../../membership-form-template/fields';
import { ProfileComponentProps } from './contracts';

export function AddressDetails<T>({
	values,
	errors,
	setFieldValue,
	touched,
	addressTypes,
	isEditing,
	addressTypeRules
}: ProfileComponentProps<T>) {
	if (!addressTypes) return <></>;
	const editableAddressTypes = addressTypes.filter(t => {
		const typeRule = addressTypeRules.find(r => r.name === t);
		if (typeRule && typeRule.editable === false) {
			return false;
		}
		return true;
	});
	return (
		<Accordion
			title={
				<Typography variant="h5" component="h3">
					{isEditing ? 'Edit address' : 'Address'}
				</Typography>
			}
		>
			<AccordionDetails>
				<Spin spinning={!addressTypes}>
					<MembershipAddressesField<T>
						key="addresses"
						field={{
							name: 'addresses',
							label: '',
							fieldType: MembershipFormFieldTypes.AddressesField
						}}
						isEditing={isEditing}
						addressTypes={addressTypes}
						editableAddressTypes={editableAddressTypes}
						setFieldValue={setFieldValue}
						value={values['addresses']}
						errors={errors}
						touched={touched}
					/>
					{isEditing ? (
						<Button
							sx={{ marginTop: '1rem' }}
							variant="secondary"
							startIconName="Add"
							onClick={() => {
								const addressesValue = [...values['addresses']];
								addressesValue.push({
									trackingId: nanoid(),
									id: null,
									addressTypeName: editableAddressTypes[0],
									addressTypeId: addressTypes.findIndex(a => editableAddressTypes.includes(a)),
									formatted: '',
									rawAddressInput: '',
									address1: '',
									building: '',
									locality: '',
									postcode: '',
									state: '',
									country: '',
									lat: null,
									lng: null
								});
								setFieldValue('addresses', addressesValue);
							}}
						>
							Add new
						</Button>
					) : null}
				</Spin>
			</AccordionDetails>
		</Accordion>
	);
}
